const typography: any = {
  fontFamily: "'Plus Jakarta Sans', sans-serif;",

  h1: {
    fontWeight: 700,
    fontSize: '3.5rem',
    lineHeight: '4rem',
  },

  h2: {
    fontWeight: 700,
    fontSize: '3rem',
    lineHeight: '3.5rem',
  },

  h3: {
    fontWeight: 700,
    fontSize: '2.4rem',
    lineHeight: '3rem',
  },

  h4: {
    fontWeight: 600,
    fontSize: '1.9rem',
    lineHeight: '2.4rem',
  },

  h5: {
    fontWeight: 600,
    fontSize: '1.45rem',
    lineHeight: '2rem',
  },

  h6: {
    fontWeight: 600,
    fontSize: '1.2rem',
    lineHeight: '1.7rem',
  },

  button: {
    textTransform: 'capitalize',
    fontWeight: 600,
    fontSize: '1.05rem',
  },

  body1: {
    fontSize: '1.08rem',
    fontWeight: 400,
    lineHeight: '1.8rem',
  },

  body2: {
    fontSize: '1rem',
    letterSpacing: '0rem',
    fontWeight: 400,
    lineHeight: '1.6rem',
  },

  subtitle1: {
    fontSize: '1.05rem',
    fontWeight: 400,
  },

  subtitle2: {
    fontSize: '1rem',
    fontWeight: 400,
  },
};

export default typography;